<template>
    <div class="partner-order">
        <div class="partner-binding">
            <p class="partner-bindingTitle partner-title">即刻绑定邮箱 专享两大福利</p>
            <p class="partner-bindingSubTitle partner-subTitle">常规航次享额外9折！指定航次享深度特惠！</p>
            <div class="partner-bindingLink">
                <router-link class="partner-register-link" to="/Rccl.Partner/Partner/Register" target="_self">注册</router-link>
                <router-link class="partner-login-link" to="/Rccl.Partner/Partner/Login" target="_self">登录</router-link>
            </div>
        </div>
        <p class="partner-orderTitle partner-title">预订流程</p>
        <div class="partner-order-container">
            <div class="partner-orderProcess">
                <div class="partner-orderItem">
                    <div><span>1</span></div>
                    <p>注册成为<br>企业用户</p>
                </div>
                <div class="partner-orderItem">
                    <div><span>2</span></div>
                    <p>邮箱激活</p>
                </div>
                <div class="partner-orderItem">
                    <div><span>3</span></div>
                    <p>
                        选择中国出发/<br>
                        海外出发航次
                    </p>
                </div>
                <div class="partner-orderItem">
                    <div><span>4</span></div>
                    <p>选择房型</p>
                </div>
                <div class="partner-orderItem">
                    <div><span>5</span></div>
                    <p>填写<br>乘客信息</p>
                </div>
                <div class="partner-orderItem">
                    <div><span>6</span></div>
                    <p>提交及<br>支付订单</p>
                </div>
                <div class="partner-orderItem">
                    <div><span>7</span></div>
                    <p>短信及<br>邮箱确认</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "NotPartner"
}
</script>

<style lang="less" scoped>
.partner-order {
    background-color: white;
    padding-top: 100px;
    padding-bottom: 50px;
    .partner-binding {
        text-align: center;
        .partner-bindingSubTitle {
            margin-bottom: 60px;
        }
        .partner-bindingLink a, .partner-bindingLink a:hover, .partner-bindingLink a:visited {
            display: inline-block;
            width: 340px;
            height: 81px;
            line-height: 77px;
            text-align: center;
            border-radius: 42px;
            background-color: #fcc301;
            color: #041447;
            font-size: 30px;
            text-decoration: none;
            font-weight: 400;
            letter-spacing: 4px;
            border: solid 2px #fcc301;
        }
        .partner-bindingLink a.partner-login-link, .partner-bindingLink a.partner-login-link:hover
        , .partner-bindingLink a.partner-login-link :visited {
            background-color: transparent;
        }
        .partner-bindingLink > a:last-child {
            margin-left: 52px;
        }
    }

    .partner-orderTitle {
        margin-top: 100px;
        margin-bottom: 50px;
    }

    .partner-order-container {
        width: 1200px;
        padding-left: 40px;
        margin: auto;
        .partner-orderProcess {
            overflow: hidden;
            text-align: center;
            .partner-orderItem {
                float: left;
                > div:before {
                    content: '';
                    width: 22px;
                    height: 2px;
                    border: 1px dashed #006bb7;
                    display: inline-block;
                    margin-right: 6px;
                    vertical-align: middle;
                    position: relative;
                    top: -10px;
                }
                > div:after {
                    content: '';
                    width: 22px;
                    height: 2px;
                    border: 1px dashed #006bb7;
                    display: inline-block;
                    margin-left: 6px;
                    margin-right: 2px;
                    vertical-align: middle;
                    position: relative;
                    top: -10px;
                }
                > div span {
                    width: 100px;
                    text-align: center;
                    height: 100px;
                    line-height: 100px;
                    border: 1px solid #006bb7;
                    border-radius: 50px;
                    color: #e0e2e8;
                    display: inline-block;
                    background-color: #006bb7;
                    font-size: 40px;
                    font-weight: 500;
                }
                > p {
                    margin-top: 32px;
                    margin-bottom: 0;
                    color: #333333;
                    font-size: 16px;
                    line-height: 36px;
                }
            }
            .partner-orderItem:first-child>div:before {
                border: none;
            }
            .partner-orderItem:last-child>div:after {
                border: none;
            }
        }
    }

}
@media only screen and (max-width: 1366px) {
    .partner-order {
        transform: scale(0.85);
    }
}

@media (max-width: 1200px) and (min-width: 768px) {
    .partner-order-container .partner-orderProcess .partner-orderItem > div span {
        width: 62px;
        height: 62px;
        line-height: 62px;
        border-radius: 31px;
    }
}

</style>